import $ from 'jquery';
import { ALERT_MESSAGE_CLASS, LOADING_CLASS, SUCCESS_MESSAGE_CLASS } from '../constants/classes';
import Notifications from '../global/Notifications';
import OrderService from '../services/orderService';

const SELECTORS = {
    REORDER_BUTTON: '.js-reorder-button',
}

export default class ReorderView {
    constructor($element) {
        return this.init($element)
    }

    init($element) {
        this.$element = $element;

        return this.setupHandlers()
            .createChildren()
            .enable();
    }

    setupHandlers() {
        this.onReorderButtonClickHandler = this.onReorderButtonClick.bind(this);
        return this;
    }

    async onReorderButtonClick(e) {
        const target = $(e.currentTarget);
        const orderId = target.attr('data-order-id');
        const reorderObject = {
            orderId: orderId
        };

        target.addClass(LOADING_CLASS);
        try {
            const response = await this.orderService.reorder(reorderObject);
            if (response.success) {
                if (response.redirectUrl) {
                    window.location = response.redirectUrl;
                } else {
                    this.notifications.showErrorNotification('Success', SUCCESS_MESSAGE_CLASS);
                    target.removeClass(LOADING_CLASS);
                }
            } else {
                this.notifications.showErrorNotification(response.errorMessage, ALERT_MESSAGE_CLASS);
                target.removeClass(LOADING_CLASS);
            }
        }
        catch (e) {
            target.removeClass(LOADING_CLASS);
        }
    }

    createChildren() {
        this.notifications = new Notifications();
        this.orderService = new OrderService();

        this.$reorderButton = this.$element.find(SELECTORS.REORDER_BUTTON);
        return this;
    }

    enable() {
        this.$reorderButton.on('click', this.onReorderButtonClickHandler);
        return this;
   }

    disable() {
        this.$reorderButton.off('click', this.onReorderButtonClickHandler);
        return this;
    }
}